<script lang="ts" setup>
/**
 * Layout band for pages that present content over the warm "hero" surface
 * (Home, Candidates, ...). The sand + bleeding Victoria map background itself
 * lives globally on <body> (see base/_reset.scss) rather than here, so this
 * component is transparent and just provides the flex/spacing structure.
 */
const { constrained = false, maxWidth = 'max-w-6xl' } = defineProps<{
  /** Wrap the slot in a centered column instead of letting it span the gutter. */
  constrained?: boolean;
  /** Tailwind max-width utility applied when `constrained` is true. */
  maxWidth?: string;
}>();
</script>

<template>
  <div class="page-hero">
    <div class="layout-size pt-4 pb-10 lg:py-10">
      <div
        v-if="constrained"
        class="mx-auto flex w-full flex-col gap-4 lg:gap-10"
        :class="maxWidth"
      >
        <slot />
      </div>
      <slot v-else />
    </div>
  </div>
</template>

<style scoped lang="scss">
.page-hero {
  // Grows to fill the viewport so short content doesn't leave an empty gap
  // above the footer. Background now lives globally on <body>.
  position: relative;
  flex: 1 0 auto;
}
</style>
